module.exports = __webpack_public_path__ + "img/case-question.e9c7d16d.png";